import { omitBy, pick, every, chain, includes } from 'lodash';
import { SwitchFields } from '../../Constants/vendor-attribution';

const vendorProfileOmits = [
  'related_party_desc',
  'email',
  'first_name',
  'last_name',
  'phone',
  'company_name',
];

const allSwitches = SwitchFields.concat(['related_party_statement']);

/**
 * Function to find all of the required fields and return them in an object
 *
 * @param form all of the fields in the form
 */
export function getRequiredFields(form, isVendorProfile) {
  if (isVendorProfile) {
    return omitBy(
      form,
      (value, key) =>
        includes(vendorProfileOmits, key) ||
        (includes(allSwitches, key) && value !== null),
    );
  }
  return omitBy(
    form,
    (value, key) =>
      key === 'related_party_desc' ||
      (includes(allSwitches, key) && value !== null),
  );
}

/**
 * Function to check if related party statement is clicked yes and if so
 * checks if an explanation was entered
 *
 * @param form all of the fields in the form
 */
export function hasRelatedPartyExplanation(form) {
  const relatedPartyFields = pick(form, [
    'related_party_statement',
    'related_party_desc',
  ]);

  if (form.related_party_statement) {
    return every(relatedPartyFields);
  }

  return true;
}

/**
 * Creates an array of the missing fields from the submitted form
 * @param {object} form all of the fields and values from submitted form
 *
 */
export function findMissingFields(form) {
  const requiredFields = getRequiredFields(form);

  return chain(requiredFields).omitBy().keys().value();
}
